import { Col, Row, Skeleton } from 'antd';
import React, { FC, useEffect, useState } from 'react';
import { Students } from '../../../../../../models/InstituteModel/students.model';
import { useParams } from 'react-router-dom';
import PhoneIcon from '../../../../../../assets/icons/phone.svg';
import MailIcon from '../../../../../../assets/icons/mail.svg';
import BlockeIcon from '../../../../../../assets/icons/close-red-icon.svg';
import CapIcon from '../../../../../../assets/icons/students-cap.svg';
import CalendarIcon from '../../../../../../assets/icons/calendar.svg';

import './details.scss';
import StudentService from '../../../../../../services/InstituteService/student.service';
import ButtonComponent from '../../../../../../shared/components/ButtonComponent';
import { StudentPasswordForm } from '../StudentPasswordForm';
export const Details: FC = (props: any) => {
  const params: any = useParams();
  const [studentDetails, setStudentDetails] = useState<Students>({});
  const [loading, setLoading] = useState<boolean>(true);
  const [showDrawer, setShowDrawer] = useState<boolean>(false);

  const fetchStudentDetails = () => {
    if (params?.studentId) {
      StudentService.getStudentsDetails(
        params?.studentId,
        (details) => {
          setStudentDetails(details);
        },
        () => {},
        () => {
          setLoading(false);
        }
      );
    }
  };

  useEffect(() => {
    fetchStudentDetails();
  }, []);

  return (
    <div className='details__container'>
      {loading ? (
        <Row gutter={16} className='details__wrapper'>
          <Col span={12}>
            <Skeleton avatar paragraph={{ rows: 4 }} />
          </Col>
          <Col span={12}>
            <Skeleton avatar paragraph={{ rows: 4 }} />
          </Col>
        </Row>
      ) : (
        <Row gutter={16} className='details__wrapper'>
          <Col span={12}>
            <p className='details__title'>Profile details</p>

            <div className='student__details'>
              <div className='student-details__wrapper'>
                <div className='student-profile__wrapper'>
                  {/* <img src={studentDetails?.} /> */}
                  <div className='student-name__wrapper'>
                    <p className='student__name'>{studentDetails?.name}</p>
                    <p>{studentDetails?.id}</p>
                  </div>
                </div>
                <Row className='student-institute-details__wrapper'>
                  <Col span={8}>
                    <div className='student-instiute__details'>
                      <img src={CapIcon} />
                      <p className='text-capitalize'>
                        {studentDetails?.classRoom?.name}
                      </p>
                    </div>
                  </Col>
                  <Col span={16}>
                    <div className='student-instiute__details'>
                      <img src={PhoneIcon} />
                      <p>{studentDetails?.phoneNumber}</p>
                    </div>
                  </Col>

                  <Col span={8}>
                    <div className='student-instiute__details'>
                      <img src={CalendarIcon} />
                      <p>{studentDetails?.dob}</p>
                    </div>
                  </Col>
                  <Col span={16}>
                    <div className='student-instiute__details'>
                      <img src={MailIcon} />
                      <p>{studentDetails?.email}</p>
                    </div>
                  </Col>
                  {studentDetails?.isBlocked && (
                    <Col span={16}>
                      <div className='student-instiute__details'>
                        <img src={BlockeIcon} />
                        <p>{studentDetails?.blockedReason}</p>
                      </div>
                    </Col>
                  )}
                </Row>
                <Row className='student-institute-details__wrapper'>
                  <Col span={8}>
                    <ButtonComponent
                      className='header-add-btn'
                      buttonContent={'Update Password'}
                      type='primary'
                      onClick={() => {
                        setShowDrawer(true);
                      }}
                    />
                  </Col>
                  <StudentPasswordForm
                    open={showDrawer}
                    setOpen={setShowDrawer}
                    onClose={() => setShowDrawer(false)}
                    studentData={studentDetails}
                  />
                </Row>
              </div>
            </div>
          </Col>
          <Col span={12}>
            <p className='details__title'>Institute details</p>

            <div className='institute__details'>
              <div className='institute-details__wrapper'>
                <div className='institute-profile__wrapper'>
                  <img src={studentDetails?.institute?.logoUrl} />
                  <div className='institute-name__wrapper'>
                    <p className='institute__name'>
                      {studentDetails?.institute?.name}
                    </p>
                    <p>{studentDetails?.branch?.name}</p>
                  </div>
                </div>
                <Row
                  className='student-institute-details__wrapper'
                  justify='space-between'
                >
                  <Col span={3}>
                    <div className='institute-details__wrapper'>
                      <p>Class</p>
                      <p className='institute__detail'>
                        {studentDetails?.classRoom?.name}
                      </p>
                    </div>
                  </Col>
                  <Col span={3}>
                    <div className='institute-details__wrapper'>
                      <p>Section</p>
                      <p className='institute__detail'>
                        {studentDetails?.section?.name}
                      </p>
                    </div>
                  </Col>
                  <Col span={12}>
                    <div className='institute-details__wrapper'>
                      <p>Roll No.</p>
                      <p className='institute__detail'>
                        {studentDetails?.rollNumber}
                      </p>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
        </Row>
      )}
    </div>
  );
};
